import { styled } from 'baseui'

export const QuestAnchor = styled('div', {
  width: '100%',
})

export const QuestRow = styled<'button', { $sold: boolean }>('button', ({ $theme, $sold }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  width: '100%',
  minHeight: '2.5rem',
  paddingTop: '0.125rem',
  paddingBottom: '0.125rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.625rem',
  borderRadius: '0.75rem',
  border: '1px solid transparent',
  backgroundColor: $sold ? $theme.colors.positive50 : 'transparent',
  color: $theme.colors.contentPrimary,
  textAlign: 'left',
  cursor: $sold ? 'default' : 'pointer',
  font: 'inherit',
  transition: 'background-color 0.12s, border-color 0.12s, box-shadow 0.12s',
  ...($sold
    ? {}
    : {
        ':hover': {
          backgroundColor: $theme.colors.bg050,
          borderColor: $theme.colors.primary450,
        },
      }),
  ':focus-visible': {
    outline: 'none',
    boxShadow: `0 0 0 0.1875rem ${$theme.colors.accent}`,
  },
}))

export const QuestIcon = styled<'span', { $sold: boolean }>('span', ({ $theme, $sold }) => ({
  position: 'relative',
  display: 'grid',
  placeItems: 'center',
  width: '1.75rem',
  height: '1.75rem',
  borderRadius: '999px',
  backgroundColor: $sold ? $theme.colors.white : $theme.colors.bg050,
  flexShrink: 0,
}))

export const QuestCheck = styled<'span', { $hidden: boolean }>('span', ({ $theme, $hidden }) => ({
  position: 'absolute',
  right: '-0.3125rem',
  bottom: '-0.3125rem',
  display: $hidden ? 'none' : 'inline-flex',
  borderRadius: '999px',
  backgroundColor: $theme.colors.white,
  color: $theme.colors.positive500,
}))

export const QuestBody = styled('span', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.125rem',
  flexGrow: 1,
  minWidth: 0,
})

export const QuestTitle = styled<'span', { $sold: boolean }>('span', ({ $theme, $sold }) => ({
  fontSize: '0.8125rem',
  lineHeight: '1.125rem',
  fontWeight: 600,
  color: $sold ? $theme.colors.positive600 : $theme.colors.contentPrimary,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}))

export const QuestHint = styled<'span', { $sold: boolean }>('span', ({ $theme, $sold }) => ({
  fontSize: '0.6875rem',
  lineHeight: '0.875rem',
  fontWeight: 600,
  color: $sold ? $theme.colors.positive600 : $theme.colors.warning600,
}))

export const QuestArrow = styled<'span', { $hidden: boolean }>('span', ({ $theme, $hidden }) => ({
  display: $hidden ? 'none' : 'inline-flex',
  flexShrink: 0,
  color: $theme.colors.mono500,
}))

export const TooltipText = styled('p', {
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontSize: '0.75rem',
  lineHeight: '1.4',
})

export const TooltipOverrides = {
  Body: { style: { zIndex: 1000, maxWidth: '18rem' } },
}
